import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import C1 from '../assets/raj/1.jpeg'
import C2 from '../assets/raj/c2.jpeg'
import C3 from '../assets/raj/c3.jpeg'
import C4 from '../assets/raj/c4.jpeg'
import C5 from '../assets/raj/c5.jpeg'
import C6 from '../assets/raj/c6.jpeg'
import C7 from '../assets/raj/c7.jpeg'
import C8 from '../assets/raj/c8.jpeg'
import C9 from '../assets/raj/c9.jpeg'
import C10 from '../assets/raj/c10.jpeg'
import C11 from '../assets/raj/c11.jpeg'
import C12 from '../assets/raj/c12.jpeg'
import C13 from '../assets/raj/c13.jpeg'
import C14 from '../assets/raj/c14.jpeg'
import C15 from '../assets/raj/c15.jpeg'
import Lift1 from '../assets/raj/lift1.jpeg'
import Lift2 from '../assets/raj/lift2.jpeg'
import Medical from '../assets/raj/medical-store.jpeg'
import WA1 from '../assets/raj/W1.webp'
import WA2 from '../assets/raj/W2.webp'
import WA3 from '../assets/raj/W3.webp'
import WA4 from '../assets/raj/W4.webp'
import WA5 from '../assets/raj/W5.webp'
import WA6 from '../assets/raj/W6.webp'
import WA7 from '../assets/raj/W7.webp'
import WA8 from '../assets/raj/W8.webp'
import WA9 from '../assets/raj/W9.webp'
import WA10 from '../assets/raj/W10.webp'
import EmerImg from '../assets/raj/emergency.jpeg'


// Styled Components (same as above until CardsGrid)
const Section = styled.section`
  padding: 4rem 2rem;
  background: linear-gradient(135deg, #f5f7fa 0%, #e9edf2 100%);
  font-family: 'Segoe UI', 'Roboto', 'Poppins', sans-serif;
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
`;

const Title = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a3c5e;
  margin-bottom: 0.5rem;
  position: relative;
  
  &:after {
    content: '';
    display: block;
    width: 80px;
    height: 4px;
    background: brown;
    margin: 1rem auto 0;
    border-radius: 2px;
  }
`;

const Subtitle = styled.p`
  text-align: center;
  color: #5a6e7c;
  font-size: 1.1rem;
  margin-bottom: 3rem;
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FacilityCard = styled.div`
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }
`;

const CardHeader = styled.div`
  background: linear-gradient(135deg, #C00707 0%, #A62C2C 100%);
  padding: 1rem;
  text-align: center;
`;

const FacilityName = styled.h3`
  color: white;
  font-size: 1.2rem;
  margin: 0;
  font-weight: 600;
`;

const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  height: 220px;
  overflow: hidden;
  background: #e0e0e0;
`;

const SlideWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
`;

const Slide = styled.div`
  flex: 0 0 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const CarouselButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  z-index: 10;
  
  &:hover {
    background: rgba(0, 0, 0, 0.8);
    transform: translateY(-50%) scale(1.1);
  }
`;

const PrevButton = styled(CarouselButton)`
  left: 8px;
`;

const NextButton = styled(CarouselButton)`
  right: 8px;
`;

const DotsContainer = styled.div`
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 6px;
  z-index: 10;
`;

const Dot = styled.button`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: none;
  background: ${props => props.active ? '#2c7da0' : 'rgba(255, 255, 255, 0.7)'};
  cursor: pointer;
  padding: 0;
  transition: all 0.3s ease;
  
  &:hover {
    background: #2c7da0;
    transform: scale(1.2);
  }
`;

const CardDescription = styled.div`
  padding: 1rem;
  background: white;
`;

const DescriptionText = styled.p`
  color: #666;
  font-size: 0.85rem;
  line-height: 1.4;
  margin: 0;
  text-align: center;
`;

// Carousel Component with infinite auto-scroll
const FacilityCarousel = ({ images, facilityName }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  
  // Auto-scroll functionality
  useEffect(() => {
    if (isHovered) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    
    return () => clearInterval(interval);
  }, [images.length, isHovered]);
  
  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  
  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };
  
  const goToSlide = (index) => {
    setCurrentIndex(index);
  };
  
  return (
    <CarouselContainer 
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <SlideWrapper style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
        {images.map((image, idx) => (
          <Slide 
            key={idx} 
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
      </SlideWrapper>
      
      <PrevButton onClick={goToPrevious}>❮</PrevButton>
      <NextButton onClick={goToNext}>❯</NextButton>
      
      <DotsContainer>
        {images.map((_, idx) => (
          <Dot
            key={idx}
            active={idx === currentIndex}
            onClick={() => goToSlide(idx)}
          />
        ))}
      </DotsContainer>
    </CarouselContainer>
  );
};

// Facility Data with more images for each facility
const facilities = [
  {
    id: 1,
    name: "Comfortable Waiting Area",
    description: "Spacious, well-ventilated lounges with cozy seating, complimentary WiFi, and calming decor.",
    images: [
      Lift1, WA1, WA2,WA3,WA4,WA5,WA6,WA7,WA8,WA9,WA10
    ]
  },
  {
    id: 2,
    name: "In-house Medical Store",
    description: "Pharmacy with all prescribed medicines, surgical items, and healthcare products at reasonable prices.",
    images: [
     Medical
    ]
  },
  {
    id: 3,
    name: "Emergency Care",
    description: "Level 1 trauma center with dedicated emergency physicians and advanced life support equipment.",
    images: [
      EmerImg
    ]
  },
  {
    id: 4,
    name: "Lift and Cafeteria",
    description: "High-speed elevators with wheelchair access and multi-cuisine cafeteria serving nutritious meals.",
    images: [
      Lift1, Lift2, C1,C2,C3,C4,C5,C6,C7,C8,C9,C10,C11,C12,C13,C14,C15
    ]
  }
];

// Main Component
const HospitalAmenities = () => {
  return (
    <Section>
      <Container>
        <Title>Our Premium Facilities</Title>
        <Subtitle>Experience world-class amenities designed for your comfort and care</Subtitle>
        
        <CardsGrid>
          {facilities.map((facility) => (
            <FacilityCard key={facility.id}>
              <CardHeader>
                <FacilityName>{facility.name}</FacilityName>
              </CardHeader>
              
              <FacilityCarousel 
                images={facility.images} 
                facilityName={facility.name}
              />
              
              <CardDescription>
                <DescriptionText>{facility.description}</DescriptionText>
              </CardDescription>
            </FacilityCard>
          ))}
        </CardsGrid>
      </Container>
    </Section>
  );
};

export default HospitalAmenities;